@for (option of options(); track $index) {
<div class="option-checkbox">
  <p-checkbox id="pchckbox" [value]="option.label" [formControl]="control()" />
  <label class="label-right-of-box" for="pchckbox">{{option.label}}</label>
</div>
}